import React from "react";
import { CustomSwiper, CapsuleCard } from "../../";
import localData from "../../../localData";

export default function Testimonials() {
    const {  client1,client2,client3,client4 } = localData.images;
    const {quote} = localData.svgs
    const testimonials = [
        {
            name: "monica geller",
            profession: "transponster",
            review: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry",
            icon: client4,
        },
        {
            name: "rachel green",
            profession: "transponster",
            review: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry",
            icon: client3,
        },
        {
            name: "John Ferguson",
            profession: "transponster",
            review: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry",
            icon: client1,
        },
        {
            name: "Michael Hensley",
            profession: "transponster",
            review: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry",
            icon: client2,
        },
    ];

    return (
        <section className="testimonials" id='testimonials' data-lazy-block>
            <div className="container">
                <h2 className="testimonials-title" data-lazy='fade'>testimonials</h2>
            <span className="testimonials-quote">{quote}</span>

                    <CustomSwiper
                        items={testimonials}
                        Card={CapsuleCard}
                        options={{
                            slidesPerView: 1,
                            speed: 500,
                            pagination: { clickable: true },
                            autoplay:  {
                                enabled: true,
                                stopOnLastSlide: true,
                                waitForTransition: true,
                                pauseOnMouseEnter: false,
                            },
                        }}
                    />
            </div>
        </section>
    );
}
